import { apiFetch } from './fetch';

export type PlanUsageDto = {
  plan: string;
  planDescription: string;
  creditsBalance: number;
  documents: { used: number; limit: number | null };
  recipients: { used: number; limit: number | null };
  storageBytes: { used: number; limit: number };
  inGracePeriod: boolean;
  gracePeriodEndsAt: string | null;
};

export type TrialCheckoutResponse = {
  checkoutUrl: string;
  preapprovalId?: string | null;
};

export async function fetchPlanUsage(): Promise<PlanUsageDto | null> {
  const res = await apiFetch('/api/billing/plan-usage');
  if (!res.ok) return null;
  return (await res.json()) as PlanUsageDto;
}

/** Start 7-day Pro trial checkout (MercadoPago card validation, no charge on day 0). */
export async function startTrialCheckout(input: {
  successUrl: string;
  cancelUrl: string;
}): Promise<TrialCheckoutResponse> {
  const res = await apiFetch('/api/billing/start-trial/checkout', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      successUrl: input.successUrl,
      cancelUrl: input.cancelUrl,
    }),
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => null)) as { error?: string } | null;
    throw new Error(typeof body?.error === 'string' ? body.error : 'Failed to start trial checkout');
  }
  return (await res.json()) as TrialCheckoutResponse;
}
